import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { fetchCartFilters } from "../../api/thunks";
import { CartSliceState } from "../types";

export const addFiltersExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(fetchCartFilters.pending, (state) => {
    state.filtersLoading = true;
    state.filtersError = null;
  });

  builder.addCase(fetchCartFilters.fulfilled, (state, action) => {
    const { type, filters } = action.payload;
    state.filtersLoading = false;

    if (type === "production") {
      state.productionFilters = filters?.filters;
    } else {
      state.remainsFilters = filters?.filters;
    }
  });

  builder.addCase(fetchCartFilters.rejected, (state, action) => {
    state.filtersLoading = false;
    state.filtersError = action.payload as string;
  });
};
